import type { Address } from "viem";

export const NFT_FACTORY_ADDRESS = import.meta.env.VITE_NFT_FACTORY_ADDRESS as Address | undefined;
export const NFT_MARKETPLACE_ADDRESS = import.meta.env.VITE_NFT_MARKETPLACE_ADDRESS as Address | undefined;

export const NFT_FACTORY_ABI = [
  { type: "event", name: "CollectionCreated", inputs: [
    { indexed: true, name: "collection", type: "address" }, { indexed: true, name: "creator", type: "address" },
    { indexed: false, name: "name", type: "string" }, { indexed: false, name: "symbol", type: "string" },
    { indexed: false, name: "maxSupply", type: "uint256" },
  ] },
  { type: "function", name: "createCollection", stateMutability: "nonpayable", inputs: [
    { name: "name", type: "string" }, { name: "symbol", type: "string" }, { name: "maxSupply", type: "uint256" },
    { name: "baseURI", type: "string" }, { name: "royaltyReceiver", type: "address" }, { name: "royaltyBps", type: "uint96" },
  ], outputs: [{ name: "collection", type: "address" }] },
] as const;

export const NFT_COLLECTION_ABI = [
  { type: "function", name: "ownerMint", stateMutability: "nonpayable", inputs: [{ name: "to", type: "address" }, { name: "tokenURI", type: "string" }], outputs: [{ name: "tokenId", type: "uint256" }] },
  { type: "function", name: "publicMint", stateMutability: "payable", inputs: [{ name: "quantity", type: "uint256" }], outputs: [] },
  { type: "function", name: "configurePublicMint", stateMutability: "nonpayable", inputs: [{ name: "open", type: "bool" }, { name: "price", type: "uint256" }, { name: "walletLimit", type: "uint256" }], outputs: [] },
  { type: "function", name: "approve", stateMutability: "nonpayable", inputs: [{ name: "to", type: "address" }, { name: "tokenId", type: "uint256" }], outputs: [] },
  { type: "function", name: "ownerOf", stateMutability: "view", inputs: [{ name: "tokenId", type: "uint256" }], outputs: [{ name: "", type: "address" }] },
  { type: "function", name: "getApproved", stateMutability: "view", inputs: [{ name: "tokenId", type: "uint256" }], outputs: [{ name: "", type: "address" }] },
  { type: "function", name: "publicMintPrice", stateMutability: "view", inputs: [], outputs: [{ name: "", type: "uint256" }] },
] as const;

export const NFT_MARKETPLACE_ABI = [
  { type: "function", name: "buy", stateMutability: "payable", inputs: [
    { name: "listing", type: "tuple", components: [
      { name: "seller", type: "address" }, { name: "collection", type: "address" }, { name: "tokenId", type: "uint256" },
      { name: "price", type: "uint256" }, { name: "nonce", type: "uint256" }, { name: "deadline", type: "uint256" },
    ] }, { name: "signature", type: "bytes" },
  ], outputs: [] },
  { type: "function", name: "cancelListing", stateMutability: "nonpayable", inputs: [{ name: "nonce", type: "uint256" }], outputs: [] },
  { type: "function", name: "withdrawProceeds", stateMutability: "nonpayable", inputs: [], outputs: [] },
  { type: "function", name: "proceeds", stateMutability: "view", inputs: [{ name: "account", type: "address" }], outputs: [{ name: "", type: "uint256" }] },
  { type: "function", name: "owner", stateMutability: "view", inputs: [], outputs: [{ name: "", type: "address" }] },
  { type: "function", name: "feeRecipient", stateMutability: "view", inputs: [], outputs: [{ name: "", type: "address" }] },
  { type: "function", name: "platformFeeBps", stateMutability: "view", inputs: [], outputs: [{ name: "", type: "uint96" }] },
  { type: "function", name: "setFeeConfiguration", stateMutability: "nonpayable", inputs: [{ name: "recipient", type: "address" }, { name: "feeBps", type: "uint96" }], outputs: [] },
  { type: "function", name: "transferOwnership", stateMutability: "nonpayable", inputs: [{ name: "newOwner", type: "address" }], outputs: [] },
] as const;

export const NFT_LISTING_TYPES = {
  Listing: [
    { name: "seller", type: "address" }, { name: "collection", type: "address" },
    { name: "tokenId", type: "uint256" }, { name: "price", type: "uint256" },
    { name: "nonce", type: "uint256" }, { name: "deadline", type: "uint256" },
  ],
} as const;
